import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import DocumentUploadForm from "@/components/DocumentUploadForm";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lockedOwnership?: string;
  allowedOwnershipValues?: string[];
  initialFiles?: File[];
  /** Show the "Select file(s) from Evidence Base" escape-hatch button. Defaults to true to preserve existing behavior. */
  showEvidenceBaseEscapeHatch?: boolean;
}

const UploadDocument = ({ open, onOpenChange, lockedOwnership, allowedOwnershipValues, initialFiles, showEvidenceBaseEscapeHatch = true }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[1024px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-lg font-bold">Upload Documents</DialogTitle>
          <DialogDescription>Fill in metadata for each document before saving.</DialogDescription>
        </DialogHeader>
        <DocumentUploadForm
          onComplete={() => onOpenChange(false)}
          lockedOwnership={lockedOwnership}
          allowedOwnershipValues={allowedOwnershipValues}
          initialFiles={initialFiles}
          hideHeader
          showEvidenceBaseEscapeHatch={showEvidenceBaseEscapeHatch}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadDocument;
